import * as Sentry from "@sentry/react";

/**
 * Handler para `.catch()` en llamadas fire-and-forget a la API.
 *
 * Sustituye a `.catch(() => {})`. Mantiene EXACTAMENTE el mismo flujo —la
 * promesa se absorbe y la UI no se rompe— pero deja rastro en consola y en
 * Sentry.
 *
 * Por qué importa: un `catch` vacío sobre una llamada a la API convierte un
 * fallo real en "no pasó nada". El caso típico es borrar una meta: desaparece
 * de la pantalla, el DELETE falla, y reaparece en el siguiente refetch sin que
 * el usuario ni nadie se entere. Es el mismo patrón que dejó 8 de 9
 * notificaciones muertas durante meses en el backend.
 *
 * Los 403 por límite de plan NO pasan por aquí para avisar al usuario: eso ya
 * lo hace `request()` en services/api.js, que dispara el evento
 * `plan-limit-reached` antes de rechazar la promesa.
 *
 * Uso:
 *   api.metas.remove(id).catch(reportar("borrar meta"));
 *
 * @param {string} contexto Qué se intentaba hacer, en lenguaje humano.
 */
export function reportar(contexto) {
  return (error) => {
    console.error(`[Arbo] Falló: ${contexto}`, error);
    try {
      Sentry.captureException(error, { tags: { operacion: contexto } });
    } catch {
      // Sentry no configurado (dev) — el console.error ya dejó rastro.
    }
  };
}
